module.exports = __webpack_public_path__ + "img/point4.3c194f7f.png";